export const get = (object: unknown, path: any[]) =>
  path.reduce((acc, next) => (acc ? acc[next] : null), object);
